import React, { useRef, useState } from "react";
import { BiCheck, BiLink } from "react-icons/bi";
import { BsCheck } from "react-icons/bs";

export function Copyable({ value = null, onClick = null, icon = null, className = "", children, ...rest }) {
  const [copied, setCopied] = useState(false);
  const timeout = useRef(null);
  const showCopied = () => setCopied(true);
  clearTimeout(timeout.current);
  timeout.current = setTimeout(() => setCopied(false), 2000);
  const copy = async () => {
    await navigator.clipboard.writeText(value);
    showCopied();
  };
  const executeParentOnClick = async () => {
    await onClick();
    showCopied();
  };
  return (
    <div className={className} onClick={executeParentOnClick || copy} {...rest}>
      {/* {copied ? <BsCheck className='ml-2 w-5 h-5' /> : <CgCopy className='ml-2 w-5 h-3' />} */}
      {icon || (copied ? <BiCheck className="-mt-0.5 mr-0.5 w-5 h-5" /> : <BiLink className="w-4 h-4 mr-1" />)}
      {copied ? "Copied!" : children}
    </div>
  );
}
